import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import cookieConsent from './stores/cookieConsent.store';
import businessFormHelper from './data/businessFormHelper.data';

window.Alpine = Alpine;
Drupal.behaviors.alpinejs = {
  isStarted: false,
  attach() {
    if (Drupal.behaviors.alpinejs.isStarted === false) {
      // attach stores: https://alpinejs.dev/globals/alpine-store
      Alpine.store('cookieConsent', cookieConsent);

      // attach data: https://alpinejs.dev/globals/alpine-data
      Alpine.data('businessFormHelper', businessFormHelper);

      Alpine.start();
      Drupal.behaviors.alpinejs.isStarted = true;
    }
  },
};
